import { useSelector } from "react-redux";
import styles from "./index.module.scss";
import Props from "/components/common/product/props";
import Offer from "/components/common/product/offer";
import { formatType, getProductsPhotos } from "../../../../utils";
import BaltexBottom from "../bottom";
import ProductPageWrapper from "../../../pages/product/bodyWrapper";
import Sert from "../../../pages/product/sert";
import Files from "../../../pages/product/files";
import Share from "../../../pages/product/share";
import BuyWithThis from "../../../pages/product/buyWithThis";
import Images from "../../../pages/product/images";
import Stick from "../../../pages/product/stick";

export default function BaltexProductBody() {
  const { cityName } = useSelector((state) => state.location);
  const { product } = useSelector((state) => state.product);
  const photos = getProductsPhotos(product, true);

  return (
    <ProductPageWrapper
      head={
        <h1 className={styles.Title} itemProp="name">
          {formatType(product.NAME)}
        </h1>
      }
      left={
        <div id="productImages" className={styles.Photos}>
          <Stick />
          <Images
            images={photos}
            video={product.VIDEO}
            alt={`${product.NAME} ${product.ARTICLE?.VALUE} в ${cityName}`}
          />
        </div>
      }
      bottom={
        <>
          <BaltexBottom />
          <div className="container">
            <BuyWithThis isBaltex={true} ids={product.BUY_WITH_THIS} />
          </div>
        </>
      }
    >
      <div className={styles.MainInfo}>
        <div className={styles.Props}>
          {product.PROPERTIES.length > 0 && (
            <div className={styles.PropsBlock}>
              <div className={styles.PropsTitle}>Характеристики</div>
              <Props
                isGray={true}
                isBaltex={true}
                props={product.PROPERTIES}
                filterUrl={product.FILTER_URL}
              />
            </div>
          )}
          <div
            className={styles.Link}
            onClick={() => {
              const section = document.getElementById("description");
              section.click();
              section.scrollIntoView({ behavior: "smooth", block: "start" });
            }}
          >
            Перейти к описанию
          </div>
          <div className={styles.FilesAndBrands}>
            <div className={styles.Files}>
              <Files file={product.FILE} isBaltex={true} />
              <Sert sert={product.CERT} isBaltex={true} />
            </div>
          </div>
          <Share
            productName={product.NAME}
            productUrl={product.DETAIL_PAGE_URL}
            photo={`${photos?.[0] && `${photos[0]}/small.webp`}`}
          />
        </div>
        {product.CATALOG && (
          <div>
            <div className={styles.Buy}>
              <Offer
                key={product.ID}
                isDetail={true}
                product={product}
                isBaltex={true}
              />
            </div>
          </div>
        )}
      </div>
    </ProductPageWrapper>
  );
}
